import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Apply from "@/pages/Apply";
import ProgramDetail from "@/pages/ProgramDetail";
import DashboardLayout from "@/components/DashboardLayout";
import BorrowerDashboard from "@/pages/dashboard/BorrowerDashboard";
import TemplateGallery from "@/pages/TemplateGallery";
import BrokerDashboard from "@/pages/dashboard/BrokerDashboard";
import LoanRepDashboard from "@/pages/dashboard/LoanRepDashboard";
import AdminDashboard from "@/pages/dashboard/AdminDashboard";
import Applications from "@/pages/dashboard/Applications";
import ApplicationDetail from "@/pages/dashboard/ApplicationDetail";
import NewApplication from "@/pages/dashboard/NewApplication";
import DocumentsPage from "@/pages/dashboard/DocumentsPage";
import FundingPrograms from "@/pages/dashboard/FundingPrograms";
import Settings from "@/pages/dashboard/Settings";
import UsersAdmin from "@/pages/dashboard/UsersAdmin";
import Qualify from "@/pages/dashboard/Qualify";
import PublicUpload from "@/pages/PublicUpload";
import "@/App.css";

function Protected({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center text-slate-400" data-testid="app-loading">
        Loading workspace…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app" replace />;
  return children;
}

function RoleHome() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "admin") return <AdminDashboard />;
  if (user.role === "loan_rep") return <LoanRepDashboard />;
  if (user.role === "broker") return <BrokerDashboard />;
  return <BorrowerDashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/templates" element={<TemplateGallery />} />
          <Route path="/programs/:slug" element={<ProgramDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/apply/:code" element={<Apply />} />
          <Route path="/upload/:token" element={<PublicUpload />} />

          <Route
            path="/app"
            element={
              <Protected>
                <DashboardLayout />
              </Protected>
            }
          >
            <Route index element={<RoleHome />} />
            <Route path="applications" element={<Applications />} />
            <Route path="applications/new" element={<NewApplication />} />
            <Route path="applications/:id" element={<ApplicationDetail />} />
            <Route path="documents" element={<DocumentsPage />} />
            <Route path="programs" element={<FundingPrograms />} />
            <Route path="qualify" element={<Qualify />} />
            <Route path="settings" element={<Settings />} />
            <Route
              path="users"
              element={
                <Protected roles={["admin"]}>
                  <UsersAdmin />
                </Protected>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
